import { copyText } from "@/lib/http";
import { cn } from "@/lib/utils";

const STATUS = {
  connected: { t: "Connected", c: "#D4FF3A" },
  not_connected: { t: "Not connected", c: "#6B6B7B" },
  error: { t: "Error", c: "#FF3B5C" },
  managed: { t: "Managed · ready", c: "#D4FF3A" },
};

export const StatusLight = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.not_connected;
  return (
    <span data-testid={testId} className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-wider" style={{ color: s.c }}>
      <span className={cn("w-2 h-2 rounded-full", status === "connected" || status === "managed" ? "mh-pulse" : "")} style={{ background: s.c }} />
      {s.t}
    </span>
  );
};

export const ModeSwitch = ({ value, onChange, disabled, options, testId }) => (
  <div className="inline-flex p-1 rounded-full border border-white/10 bg-white/[0.03]" data-testid={testId}>
    {options.map((o) => (
      <button key={o.value} type="button" disabled={disabled} onClick={() => onChange(o.value)} data-testid={`${testId}-${o.value}`}
        className={cn("px-4 h-9 rounded-full text-xs font-medium whitespace-nowrap transition-[background-color,color] duration-200 disabled:cursor-not-allowed",
          value === o.value ? "bg-white text-black" : "text-muted-foreground hover:text-foreground")}>
        {o.label}
      </button>
    ))}
  </div>
);

export const Input = ({ label, testId, ...props }) => (
  <label className="block min-w-0">
    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</span>
    <input {...props} data-testid={testId}
      className="mt-1.5 w-full h-10 px-3.5 rounded-lg bg-white/[0.03] border border-white/10 text-sm outline-none focus:border-[#D4FF3A]/60 transition-colors disabled:opacity-50" />
  </label>
);

export const Btn = ({ children, variant = "ghost", testId, ...props }) => (
  <button {...props} data-testid={testId}
    className={cn("inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full text-sm transition-[background-color,border-color,transform] active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed",
      variant === "primary" ? "bg-[#D4FF3A] text-black font-semibold hover:bg-[#e2ff73]" : "border border-white/15 hover:bg-white/5 hover:border-white/30")}>
    {children}
  </button>
);

export const Copyable = ({ label, value, testId, onCopy }) => (
  <div className="min-w-0">
    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</div>
    <div className="mt-1.5 flex items-center gap-2">
      <code className="flex-1 min-w-0 truncate px-3 h-10 leading-10 rounded-lg bg-white/[0.04] border border-white/10 text-xs" data-testid={testId}>{value}</code>
      <Btn onClick={() => { copyText(value); onCopy?.(); }} testId={`${testId}-copy`}>Copy</Btn>
    </div>
  </div>
);
